export const outerLink = {
  스쿨플랫_공통_앱사용가이드_링크: 'https://guide-schoolflat.oopy.io',
  스쿨플랫_시그니처교재_콘텐츠자료실_링크:
    'https://www.notion.so/freewheelin/d22c27ad00544dca99eace3d80356837',
  스쿨플랫_유형분석_취약유형_링크:
    'https://www.notion.so/freewheelin/722e3b119a574951aaeb9a92f6fa318e',
  스쿨플랫_학력평가_시험_메뉴얼_링크:
    'https://freewheelin.notion.site/879377bbe4c0416b8466f9deae653981',
  스쿨플랫_프린트연결이_끊겼을_경우_링크:
    'https://freewheelin.notion.site/c273491ade784ce9b78f2e22ce046079',
  스쿨플랫_인쇄하기_가이드_링크:
    'https://freewheelin.notion.site/PC-ca7df8aaec4944668792ca21fdb95988',
  매쓰플랫_인쇄하기_가이드_링크:
    'https://hill-structure-ae3.notion.site/PC-cfdc82b947aa42029f19614a2b369cba',
  스쿨플랫_공지사항_링크:
    'https://www.notion.so/freewheelin/8c548c575ca745b2a11f70ae1a2cc1e5?v=45134a730015455f8c39fa040d9fad32',
  스쿨플랫_카카오톡_채널_링크: 'http://pf.kakao.com/_hxoxjkG',
  매쓰플랫_카카오톡_채널_링크: 'http://pf.kakao.com/_jxcuwC',
  스쿨플랫_홈페이지_링크: 'https://www.schoolflat.com',
  스쿨플랫_PC앱_다운로드_링크: 'https://schoolflat.com/p.exe',
  KMM_홍보물_링크: 'https://hill-structure-ae3.notion.site/KMM-231f64225de480e49aeee0157b8f1d9d',
  KMM_샘플시험지_링크:
    'https://hill-structure-ae3.notion.site/253f64225de481a3b8efea355c783109?source=copy_link',
  KMM_후기영상_링크:
    'https://hill-structure-ae3.notion.site/253f64225de481ab9bd2ff8add7fe842?source=copy_link',
  KMM_연간_시험일정_범위_링크:
    'https://hill-structure-ae3.notion.site/2c3f64225de480f194eef72e7fb0af50?source=copy_link',
  기출분석_템플릿_다운로드_링크:
    'https://drive.usercontent.google.com/u/0/uc?id=1zG1pN6H-WO8nfA1uoILh05M-yVe8sCmB&export=download',
  홈화면_프레이머_링크:
    'https://updated-contents.framer.website/support-for-most-commercial-textbooks',
  매쓰플랫_로그인화면_배너_링크:
    'https://updated-contents.framer.website/support-for-most-commercial-text-new-tab',
  매쓰플랫_홈페이지_개인정보_처리방침: 'https://www.mathflat.com/private',
  스쿨플랫_홈페이지_개인정보_처리방침: 'https://www.schoolflat.com/private',
  매쓰플랫_보고서_생성_가이드_링크:
    'https://www.mathflat.com/blog/features/18088/report_upgrade?utm_source=app&utm_medium=cta&utm_campaign=report_update&utm_content=260114_report_update',
  스쿨플랫_보고서_생성_가이드_링크:
    'https://guide-schoolflat.oopy.io/1c3f6422-5de4-81a3-a161-c339addaa7df',
  매쓰플랫_마이DB_오픈_이벤트_링크: 'https://www.mathflat.com/blog/news/18466/2604_mydb_openevent',
  학교별기출_정책_가이드_링크: 'https://freewheelin.notion.site/375feddce6718153b148c2f5e89194f0',
}
